module.exports = __webpack_public_path__ + "static/img/exam-3-bg.7430a7e.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/exam-3-bg.png
// module id = SMHr
// module chunks = 1